/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@monsma/XDL/Helpers";
import InfoCircleSolid from "@monsma/XDL/Icons/InfoCircleSolid";
import Users from "@monsma/XDL/Icons/Users";
import { css } from "styled-components";

wishListSharingStatusStyles.privateIcon = {
    src: InfoCircleSolid,
    size: 15,
    css: css`
        margin-left: 5px;
    `,
};

wishListSharingStatusStyles.sharedIcon = {
    src: Users,
    color: "common.ui2",
    size: 15,
    css: css`
        margin-top: -2px;
        margin-right: 5px;
        vertical-align: middle;
    `,
};

wishListSharingStatusStyles.privateTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 5px;
            display: flex;

            &:hover {
                ${IconWrapper} {
                    color: ${getColor("common.ui3")};
                }
            }

            @media print {
                display: none;
            }
        `,
    },
};

wishListSharingStatusStyles.statusText = {
    css: css`
        font-size: 13px;
        letter-spacing: 0;
        line-height: 22px;
        padding-right: 15px;
        display: flex;
        align-items: center;

        ${screen("only", "md")} {
            padding-left: 7.5px;
            margin-top: 5px;
        }
    `,
};
